import React, {FC, Fragment, useMemo, useState} from 'react';

import {AiReviewConversationsHarvestingV2Job} from '../../../../../libs/shared/core/src/models/api/jobModel';
import {AiInaccurateTagBannerState} from '../../../../store/panels/app/banners/bannersState';
import {AiReportedInaccurateTagBanner} from './aiReportedInaccurateTagBanner';
import {AiReviewConversationsHarvestingBannerV2} from './aiReviewConversationsHarvestingBannerV2';

/*
 * Props.
 */

interface AiTaggingBannersProps {
  jobs: ReadonlyArray<AiReviewConversationsHarvestingV2Job>;
  reportInaccurateTagBanners: ReadonlyArray<AiInaccurateTagBannerState>;
}

/*
 * Component.
 */

export const AiTaggingBanners: FC<AiTaggingBannersProps> = (props) => {
  const {jobs, reportInaccurateTagBanners} = props;

  const [dismissedJobIds, setDismissedJobIds] = useState<ReadonlyArray<number>>([]);

  /*
   * Event handlers.
   */

  const onAiTaggingHarvestingJobDismiss = (jobId: number) => {
    setDismissedJobIds((jobIds) => [...jobIds, jobId]);
  };

  const visibleJobs = useMemo(
    () => jobs.filter((j) => !dismissedJobIds.includes(j.id)),
    [jobs, dismissedJobIds],
  );

  /*
   * Render.
   */

  return (
    <>
      {visibleJobs.map((job) => (
        <Fragment key={job.id}>
          <AiReviewConversationsHarvestingBannerV2
            job={job}
            onDismissClick={onAiTaggingHarvestingJobDismiss}
          />
        </Fragment>
      ))}
      {reportInaccurateTagBanners.map((banner) => (
        <Fragment key={banner.uid}>
          <AiReportedInaccurateTagBanner bannerState={banner} />
        </Fragment>
      ))}
    </>
  );
};
